import _Paper from "@material-ui/core/esm/Paper";
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import React from 'react';
import classnames from 'classnames';
import { GiveawayProductColorSelect } from '../giveaway-product-color-select';
import { GiveawayProductSizeSelect } from '../giveaway-product-size-select';
import { ImageLoading } from '../image-loading';
import { GiveawayMultipleProductsSelection } from '../giveaway-multiple-products-selection';
import classes from './giveaway-product-card.scss';
export class GiveawayProductCardComponent extends React.PureComponent {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "handleImageClick", e => {
      const {
        product,
        image,
        openImage
      } = this.props;
      if (!product) {
        return;
      }
      openImage(image, product.name);
      e.stopPropagation();
    });
    _defineProperty(this, "handleColorChange", color => {
      const {
        product,
        setProductColor,
        isOneProduct
      } = this.props;
      if (!product) {
        return;
      }
      setProductColor(product._id, color, isOneProduct);
    });
    _defineProperty(this, "handleSizeChange", size => {
      const {
        product,
        setProductSize,
        isOneProduct
      } = this.props;
      if (!product) {
        return;
      }
      setProductSize(product._id, size, isOneProduct);
    });
  }
  render() {
    const {
      product,
      primaryColor,
      selectable,
      onCardClick = () => ({}),
      selectedColors,
      isReserve,
      size,
      sizeSettings,
      showSelection,
      image,
      isOneProduct,
      shouldShowSizeSelection
    } = this.props;
    if (!product) {
      return;
    }
    const {
      name,
      _id,
      available
    } = product;
    const paperClasses = {
      root: classnames(classes.paper, {
        [classes.inlinePaper]: selectable
      })
    };
    const disabled = !available && isReserve;
    return /*#__PURE__*/React.createElement(_Paper, {
      classes: paperClasses
    }, /*#__PURE__*/React.createElement("div", {
      style: {
        border: `6px solid ${showSelection ? primaryColor : '#eeeeee'}`
      },
      className: classnames(classes.borderWrapper, {
        [classes.disabled]: disabled,
        [classes.inlineBorderWrapper]: selectable
      }),
      onClick: () => onCardClick(product),
      "data-giveaway-product-id": _id
    }, /*#__PURE__*/React.createElement("div", {
      className: classes.firstContentRow
    }, /*#__PURE__*/React.createElement("div", {
      className: classes.imageWrapper
    }, /*#__PURE__*/React.createElement(ImageLoading, {
      src: image,
      alt: name,
      className: classes.image,
      onClick: this.handleImageClick
    })), /*#__PURE__*/React.createElement("div", {
      className: classnames(classes.infoBlock, {
        [classes.inlineInfoBlock]: selectable
      })
    }, /*#__PURE__*/React.createElement("div", {
      className: classnames(classes.productName, {
        [classes.productNameOutOfStock]: disabled
      })
    }, name), disabled && /*#__PURE__*/React.createElement("span", {
      className: classes.outOfStock
    }, "Out of stock"), /*#__PURE__*/React.createElement(GiveawayProductColorSelect, {
      productId: _id,
      primaryColor: primaryColor,
      selectedColors: selectedColors,
      onChange: this.handleColorChange,
      selectable: selectable,
      showSelection: showSelection,
      isReserve: isReserve
    }), shouldShowSizeSelection && /*#__PURE__*/React.createElement(GiveawayProductSizeSelect, {
      productId: _id,
      product: product,
      selectedColors: selectedColors,
      sizes: sizeSettings,
      primaryColor: primaryColor,
      selectedSize: size,
      onChange: this.handleSizeChange,
      selectable: selectable,
      showSelection: showSelection,
      isReserve: isReserve
    }))), !isOneProduct && /*#__PURE__*/React.createElement(GiveawayMultipleProductsSelection, {
      showSelection: showSelection,
      product: product,
      productId: product._id
    })));
  }
}